/* eslint-disable no-param-reassign */
/* eslint-disable object-curly-newline */

import { Component, registerComponent } from 'js/component.js';
import { setCenteredMaxWidth } from 'js/helpers.js';

const componentName = 'product-family-list';
const productDetailServletEndpoint = '/bin/rockwell-automation/product-details';
const addToBomEndpoint = 'https://www.rockwellautomation.com/my/bom?catalogNumber={catalogNumber}';
const backupImage = 'https://www.rockwellautomation.com/product-images/{sku}/{sku}.jpg';
const productDetailPath = '/products/details.{catalogNumber}.html';

export class ProductFamilyList extends Component {
    elements = {
        // Display
        content: this.element.querySelector(`.${componentName}__content`),
        container: this.element.querySelector(`.${componentName}__container`),
        productGrid: this.element.querySelector(`.${componentName}__grid--main`),
        subcategoryGrid: this.element.querySelector(`.${componentName}__grid--subcategory`),
        subcategoryView: this.element.querySelector(`.${componentName}__grid--subcategory-view`),
        productTemplate: this.element.querySelector(`.${componentName}__product-template`),
        loadingContainer: this.element.querySelector(`.${componentName}__loading-container`),
        compareItems: document.querySelectorAll(`.${componentName}__compare-modal-item`),
        compareCheckboxes: document.querySelectorAll(`.${componentName}__product-compare-checkbox`),
        popupChevrons: this.element.querySelectorAll(`.${componentName}__product-popup-chevron`),
        // Pagination
        paginationForm: this.element.querySelector(`.${componentName}__pagination-form`),
        resultsPerPageSelect: this.element.querySelector('select[name="results-per-page"]'),
        // Filtering
        // productSortSelect: this.element.querySelector('select[name="product-sort"]'),
        // productSortSelectStyler: this.element.querySelector(`.${componentName}__select-styler`),
        // productSortInputsMobile: this.element.querySelectorAll(`.${componentName}__filter-group-mobile-sort input`),
        filterContainer: this.element.querySelector(`.${componentName}__filter-container`),
        filterForm: this.element.querySelector(`.${componentName}__filter-form`),
        filterList: this.element.querySelector(`.${componentName}__filter-list`),
        filterGroupTemplate: this.element.querySelector(`.${componentName}__filter-group-template`),
        sliderTemplate: this.element.querySelector(`.${componentName}__filter-slider-container-template`),
        filterClearAll: this.element.querySelector(`.${componentName}__filter-clear-button`),
        filterCheckboxes: [],
        mobileFilterCloseButtons: this.element.querySelectorAll(`.${componentName}__filter-mobile-close`),
        mobileFilterOpenButton: this.element.querySelector(`.${componentName}__header-mobile-button`),
        textSearchInput: this.element.querySelector(`.${componentName}__filter-search`),
        chipContainer: this.element.querySelector(`.${componentName}__chip-container`),
    };

    state = {
        pageIndex: 0,
        totalPages: 0,
        totalResults: 0,
        resultsPerPage: 24,
        productList: [],
        sortBy: 'default',
        textSearch: '',
        filters: {},
        filterFacets: [],
        userCompareData: window.localStorage.getItem('userCompareData') ? window.localStorage.getItem('userCompareData').split(', ') : [],
    };

    constants = {
        app: '',
        language: 'en',
        i18n: {},
        facetNameTranslations: {},
        facetValueTranslations: {},
        defaultImage: '/etc.clientlibs/rockwell-aem-base/clientlibs/clientlib-base/resources/icons/image_unavailable.svg',
        ssDefaultImage: '/etc.clientlibs/rockwell-aem-base/clientlibs/clientlib-base/resources/icons/ss_image_unavailable.svg',
        productDataToFacetMap: {
            type: 'typeVals',
            brand: 'brandVals',
            productLifeCycleStatus: 'lifeCycleVals',
        },
        listType: 'family',
        categoryIds: '',
        maxFacets: 12,
        facetsExpandedOnLoad: 8,
        countryCode: '',
        featureFacets: {
            pimBaba: {
                icon: '/etc.clientlibs/rockwell-aem-base/clientlibs/clientlib-base/resources/icons/baba-icon.svg',
                name: 'Build America, Buy America',
            },
            dpp: {
                icon: '/etc.clientlibs/rockwell-aem-base/clientlibs/clientlib-base/resources/icons/dpp-icon.svg',
                name: 'Digital Product Passport',
            },
            ecodesign: {
                icon: '/etc.clientlibs/rockwell-aem-base/clientlibs/clientlib-base/resources/icons/ecodesign-icon.svg',
                name: 'Ecodesign Directive',
            },
            repairable: {
                icon: '/etc.clientlibs/rockwell-aem-base/clientlibs/clientlib-base/resources/icons/repairable-icon.svg',
                name: 'Repairable',
            },
            registrable: {
                icon: '/etc.clientlibs/rockwell-aem-base/clientlibs/clientlib-base/resources/icons/registrable-icon.svg',
                name: 'Registrable',
            },
        },
        onlyDiscontinuedProducts: false,
    };

    // Helper method to get the appropriate default image based on app type
    getDefaultImage = () => (this.constants.app?.toLowerCase() === 'ss' ? this.constants.ssDefaultImage : this.constants.defaultImage);

    // Helper methods to conditionally show/hide spinner (custom loading for S+S pages)
    showSpinner = () => {
        if (this.constants.app?.toLowerCase() === 'ss') {
            // Show custom S+S loading state
            if (this.elements.loadingContainer) {
                this.elements.loadingContainer.style.display = 'flex';
                this.elements.productGrid.style.display = 'none';
            }
        } else {
            // Show RA spinner
            window.dispatchEvent(new CustomEvent('show-loading', null));
        }
    };

    hideSpinner = () => {
        if (this.constants.app?.toLowerCase() === 'ss') {
            // Hide custom S+S loading state
            if (this.elements.loadingContainer) {
                this.elements.loadingContainer.style.display = 'none';
                this.elements.productGrid.style.display = 'flex';
            }
        } else {
            // Hide RA spinner
            window.dispatchEvent(new CustomEvent('hide-loading', null));
        }
    };

    getProducts = async () => {
        const returnJson = {
            dataList: [],
            totalNumber: 0,
            facets: [],
        };
        try {
            let filterString = '';
            Object.entries(this.state.filters).forEach(([key, value]) => {
                filterString += `${key}=${value.join('___')}---`;
            });

            const locale = document.documentElement.lang ? document.documentElement.lang.toLocaleLowerCase() : 'en-us';
            const countryCode = locale.split('-')[1];
            const response = await fetch(`${productDetailServletEndpoint}?countryCode=${countryCode}&app=${this.constants.app}&categoryIds=${this.constants.categoryIds}&startIndex=${(this.state.pageIndex * this.state.resultsPerPage)}&numResults=${this.state.resultsPerPage}&fields=all&sortBy=${this.state.sortBy}&elasticSearch=true&textSearch=${this.state.textSearch}${this.constants.language !== 'en' ? `&isocode=${this.constants.language}` : ''}${filterString === '' ? '' : `&filters=${filterString}`}`);
            const responseBuffer = await response.arrayBuffer();
            const responseString = new TextDecoder('UTF-8').decode(responseBuffer);
            const responseJson = JSON.parse(responseString);
            returnJson.dataList = responseJson.docs;
            returnJson.totalNumber = responseJson.total;
            returnJson.facets = responseJson.facets;
        } catch (error) {
            console.warn('Error:', error);
        }
        return returnJson;
    };

    addFacets = () => {
        this.state.filterFacets.forEach((facet, index) => {
            if (facet.type === 'checkbox') {
                const facetGroup = this.elements.filterGroupTemplate.cloneNode(true);
                if (index < this.constants.facetsExpandedOnLoad) {
                    facetGroup.setAttribute('open', true);
                }
                facetGroup.classList.remove(`${componentName}__filter-group-template`);
                facetGroup.setAttribute('data-facet-name', facet.name);
                facetGroup.querySelector(`.${componentName}__filter-summary`).innerHTML = this.toTitle(this.translateFacet(facet.name, 'name')) + facetGroup.querySelector(`.${componentName}__filter-summary`).innerHTML;
                facetGroup.querySelector(`.${componentName}__filter-summary`).addEventListener('click', this.handleSummaryClick);

                facet.buckets.forEach((bucket, bucketIndex) => {
                    const checkboxTemplate = facetGroup.querySelector(`.${componentName}__filter-checkbox-container-template`).cloneNode(true);
                    checkboxTemplate.classList.remove(`${componentName}__filter-checkbox-container-template`);
                    checkboxTemplate.setAttribute('data-bucket-name', encodeURIComponent(bucket.key));

                    // Use original facet name for checkbox name if available (for Features group)
                    const checkboxName = bucket.facetName || this.constants.productDataToFacetMap[facet.name] || facet.name;
                    checkboxTemplate.querySelector(`.${componentName}__filter-checkbox`).setAttribute('name', checkboxName);

                    // Use original key for value if available (for Features group)
                    const checkboxValue = bucket.originalKey !== undefined ? bucket.originalKey : bucket.key;
                    checkboxTemplate.querySelector(`.${componentName}__filter-checkbox`).setAttribute('value', encodeURIComponent(checkboxValue));
                    checkboxTemplate.setAttribute('data-original-index', bucketIndex);
                    checkboxTemplate.querySelector(`.${componentName}__filter-checkbox`).setAttribute('name', this.constants.productDataToFacetMap[facet.name] || facet.name);
                    checkboxTemplate.querySelector(`.${componentName}__filter-checkbox`).setAttribute('id', `${encodeURIComponent(facet.name)}-${encodeURIComponent(bucket.key)}`);
                    checkboxTemplate.querySelector(`.${componentName}__filter-checkbox-count`).textContent = `(${bucket.count})`;
                    let checkboxLabel = bucket.key.replaceAll('&quot;', '"');
                    if (checkboxLabel.toLowerCase() === 'false') {
                        checkboxLabel = 'No';
                    }
                    if (checkboxLabel.toLowerCase() === 'true') {
                        checkboxLabel = 'Yes';
                    }
                    checkboxTemplate.querySelector('label').textContent = this.translateFacet(checkboxLabel.trim(), 'value') || checkboxLabel;
                    checkboxTemplate.querySelector('label').setAttribute('for', `${encodeURIComponent(facet.name)}-${encodeURIComponent(bucket.key)}`);

                    // Add icon if defined for the facet
                    if (bucket.icon) {
                        const iconElement = document.createElement('img');
                        iconElement.className = `${componentName}__filter-checkbox-icon`;
                        iconElement.src = bucket.icon;
                        iconElement.alt = `${bucket.key} icon`;
                        iconElement.style.marginRight = '4px';
                        iconElement.style.width = '16px';
                        iconElement.style.height = '16px';
                        iconElement.style.verticalAlign = 'bottom';
                        checkboxTemplate.querySelector('label').insertBefore(iconElement, checkboxTemplate.querySelector('label').firstChild);
                    }

                    facetGroup.querySelector(`.${componentName}__filter-content`).appendChild(checkboxTemplate);
                    this.elements.filterCheckboxes.push(checkboxTemplate.querySelector(`.${componentName}__filter-checkbox`));
                });

                this.elements.filterList.appendChild(facetGroup);

                facetGroup.querySelector(`.${componentName}__search-field-placeholder`).textContent = `${this.constants.i18n.Search || 'Search'} ${this.toTitle(this.translateFacet(facet.name, 'name'))}`;
                facetGroup.querySelector(`.${componentName}__filter-group-search`).setAttribute('name', this.constants.productDataToFacetMap[facet.name] || facet.name);
                if (facetGroup.querySelectorAll(`.${componentName}__filter-checkbox-container`).length > 10) {
                    facetGroup.querySelector(`.${componentName}__filter-search-container`).classList.remove('hidden');
                    facetGroup.querySelector(`.${componentName}__filter-group-search`).addEventListener('input', () => {
                        const searchValue = facetGroup.querySelector(`.${componentName}__filter-group-search`).value.toLowerCase();
                        facetGroup.querySelectorAll(`.${componentName}__filter-checkbox-container`).forEach((checkbox) => {
                            if (checkbox.querySelector('label').textContent.toLowerCase().includes(searchValue)) {
                                checkbox.classList.remove('hidden');
                            } else {
                                checkbox.classList.add('hidden');
                            }
                        });
                    });
                }
            } else if (facet.type === 'slider') {
                // const sliderContainer = this.elements.sliderTemplate.cloneNode(true);
                // sliderContainer.classList.remove(`${componentName}__filter-slider-container-template`);
                // sliderContainer.querySelector(`.${componentName}__filter-slider-label-text`).textContent = `${facet.name.replace('range-input-', '')}${facet.unit ? ` (${facet.unit})` : ''}`;
                // sliderContainer.querySelector(`.${componentName}__filter-slider-label-min`).textContent = facet.min;
                // sliderContainer.querySelector(`.${componentName}__filter-slider-label-max`).textContent = facet.max;
                // sliderContainer.querySelectorAll(`.${componentName}__filter-slider-range`).forEach((slider, index) => {
                //     slider.setAttribute('name', `${facet.name}-${index}`);
                //     slider.setAttribute('data-index', index);
                //     slider.setAttribute('min', facet.min);
                //     slider.setAttribute('max', facet.max);
                //     slider.setAttribute('step', (facet.max - facet.min) / 100);
                //     slider.setAttribute('value', index === 0 ? facet.min : facet.max);
                //     slider.setAttribute('aria-label', `${facet.name} ${index === 0 ? 'min' : 'max'}`);
                //     slider.addEventListener('change', (event) => {
                //         this.handleProductFilterChange();
                //     });
                //     slider.addEventListener('input', () => {
                //         const minInput = sliderContainer.querySelector(`.${componentName}__filter-slider-range[data-index="0"]`).valueAsNumber <= sliderContainer.querySelector(`.${componentName}__filter-slider-range[data-index="1"]`).valueAsNumber ? sliderContainer.querySelector(`.${componentName}__filter-slider-range[data-index="0"]`) : sliderContainer.querySelector(`.${componentName}__filter-slider-range[data-index="1"]`);
                //         const maxInput = sliderContainer.querySelector(`.${componentName}__filter-slider-range[data-index="0"]`).valueAsNumber > sliderContainer.querySelector(`.${componentName}__filter-slider-range[data-index="1"]`).valueAsNumber ? sliderContainer.querySelector(`.${componentName}__filter-slider-range[data-index="0"]`) : sliderContainer.querySelector(`.${componentName}__filter-slider-range[data-index="1"]`);
                //         this.fillSlider(minInput, maxInput, '#949494', '#003E7E', sliderContainer.querySelector(`.${componentName}__filter-slider-range[data-index="0"]`));
                //     });
                // });
                // this.elements.filterList.appendChild(sliderContainer);
            }
        });

        if (this.element.querySelector(`.${componentName}__filter-checkbox[name="preferredProducts"]`)) {
            this.elements.filterCheckboxes.push(this.element.querySelector(`.${componentName}__filter-checkbox[name="preferredProducts"]`));
            // Move preferredProducts checkbox to the Features group
            let featuresGroup = this.elements.filterList.querySelector(`.${componentName}__filter-group[data-facet-name="Features"] .${componentName}__filter-content`);
            const noGroupFilters = this.elements.filterList.querySelector(`.${componentName}__no-group-filters`);
            if (featuresGroup) {
                featuresGroup.prepend(this.element.querySelector(`.${componentName}__filter-checkbox-container:has(.${componentName}__filter-checkbox[name="preferredProducts"])`));
            } else {
                featuresGroup = this.elements.filterGroupTemplate.cloneNode(true);
                featuresGroup.classList.remove(`${componentName}__filter-group-template`);
                featuresGroup.setAttribute('data-facet-name', 'Features');
                featuresGroup.querySelector(`.${componentName}__filter-summary`).innerHTML = this.toTitle(this.translateFacet('Features', 'name')) + featuresGroup.querySelector(`.${componentName}__filter-summary`).innerHTML;
                featuresGroup.querySelector(`.${componentName}__filter-summary`).addEventListener('click', this.handleSummaryClick);
                featuresGroup.querySelector(`.${componentName}__filter-content`).appendChild(this.element.querySelector(`.${componentName}__filter-checkbox-container:has(.${componentName}__filter-checkbox[name="preferredProducts"])`));
                featuresGroup.open = true;
                featuresGroup.querySelector(`.${componentName}__filter-content-container`).style.display = 'block';
                if (noGroupFilters) {
                    noGroupFilters.insertAdjacentElement('afterEnd', featuresGroup);
                } else {
                    this.elements.filterList.prepend(featuresGroup);
                }
            }
            if (noGroupFilters && noGroupFilters.clientHeight === 0) {
                noGroupFilters.remove();
            }
        }
        if (this.element.querySelector(`.${componentName}__filter-checkbox[name="discontinued"]`)) {
            this.elements.filterCheckboxes.push(this.element.querySelector(`.${componentName}__filter-checkbox[name="discontinued"]`));
        }
    };

    initFacets = (facets) => {
        if (!facets) {
            return;
        }

        // Create a Features facet group for the new facets
        const featuresFacetObject = {
            name: 'Features',
            buckets: [],
            facetedProducts: 0,
            type: 'checkbox',
        };

        Object.entries(facets).forEach(([facetName, facetBuckets]) => {

            if (facetName === 'classification_features' && this.constants.listType !== 'search' && (this.constants.language === 'en' || facets.translation_classification.buckets.length === 0)) {
                this.initDynamicFacets(facetBuckets.buckets);

            } else if (facetName === 'translation_classification' && this.constants.listType !== 'search' && this.constants.language !== 'en') {
                this.initDynamicFacets(facetBuckets.buckets);

            } else if (facetName === 'classification_numValues' && this.constants.listType !== 'search') {
                // this.initNumericFacets(facetBuckets.buckets);

            } else if (facetName === 'primary_category_filter' && this.constants.listType === 'search') {
                const facetObject = {
                    name: 'Product Category',
                    buckets: [],
                    facetedProducts: 0,
                    type: 'checkbox',
                };
                if (facetBuckets.buckets && typeof facetBuckets.buckets[Symbol.iterator] === 'function') {
                    facetBuckets.buckets.forEach((bucket) => {
                        if (bucket.count === 0) {
                            return;
                        }
                        facetObject.buckets.push(bucket);
                        facetObject.facetedProducts += bucket.count;
                    });
                }
                if (facetObject.buckets.length > 1) {
                    this.state.filterFacets.push(facetObject);
                }
            } else if (facetName === 'salesOrg_repairable') {
                // Only add the REPAIRABLE bucket to Features
                if (facetBuckets.buckets && typeof facetBuckets.buckets[Symbol.iterator] === 'function') {
                    facetBuckets.buckets.forEach((bucket) => {
                        if ((bucket.key === 'REPAIRABLE') && bucket.count > 0) {
                            featuresFacetObject.buckets.push({
                                key: this.constants.featureFacets.repairable.name,
                                count: bucket.count,
                                originalKey: 'Repairable',
                                facetName,
                                icon: this.constants.featureFacets.repairable.icon
                            });
                            featuresFacetObject.facetedProducts += bucket.count;
                        }
                    });
                }
            } else if (facetName === 'registerable') {
                // Only add the "1" bucket to Features
                if (facetBuckets.buckets && typeof facetBuckets.buckets[Symbol.iterator] === 'function') {
                    facetBuckets.buckets.forEach((bucket) => {
                        if ((bucket.key === 1) && bucket.count > 0) {
                            featuresFacetObject.buckets.push({
                                key: this.constants.featureFacets.registrable.name,
                                count: bucket.count,
                                originalKey: 'Registrable',
                                facetName,
                                icon: this.constants.featureFacets.registrable.icon
                            });
                            featuresFacetObject.facetedProducts += bucket.count;
                        }
                    });
                }
            } else if (facetName === 'pim_baba') {
                // Only add the PIM_BABA bucket to Features
                if (this.constants.countryCode === 'US') {
                    if (facetBuckets.buckets && typeof facetBuckets.buckets[Symbol.iterator] === 'function') {
                        facetBuckets.buckets.forEach((bucket) => {
                            if ((bucket.key === 'PIM_BABA') && bucket.count > 0) {
                                featuresFacetObject.buckets.push({
                                    key: this.constants.featureFacets.pimBaba.name,
                                    count: bucket.count,
                                    originalKey: 'Build America, Buy America',
                                    facetName,
                                    icon: this.constants.featureFacets.pimBaba.icon
                                });
                                featuresFacetObject.facetedProducts += bucket.count;
                            }
                        });
                    }
                }
            } else if (facetName === 'sustainability') {
                if (facetBuckets.buckets && typeof facetBuckets.buckets[Symbol.iterator] === 'function') {
                    facetBuckets.buckets.forEach((bucket) => {
                        if ((bucket.key === 'sustainability') && bucket.count > 0) {
                            featuresFacetObject.buckets.push({
                                key: this.constants.featureFacets.dpp.name,
                                count: bucket.count,
                                originalKey: 'Digital Product Passport',
                                facetName,
                                icon: this.constants.featureFacets.dpp.icon
                            });
                            featuresFacetObject.facetedProducts += bucket.count;
                        }
                    });
                }

            } else if (facetName === 'ecodesign') {
                if (facetBuckets.buckets && typeof facetBuckets.buckets[Symbol.iterator] === 'function') {
                    facetBuckets.buckets.forEach((bucket) => {
                        if ((bucket.key === 'ecodesign') && bucket.count > 0) {
                            featuresFacetObject.buckets.push({
                                key: this.constants.featureFacets.ecodesign.name,
                                count: bucket.count,
                                originalKey: 'Ecodesign Directive',
                                facetName,
                                icon: this.constants.featureFacets.ecodesign.icon
                            });
                            featuresFacetObject.facetedProducts += bucket.count;
                        }
                    });
                }
            } else if (facetName === 'classification_features_name_translation') {
                this.fillTranslationFacets(this.constants.facetNameTranslations, facetBuckets.buckets);
            } else if (facetName === 'classification_features_value_translation') {
                this.fillTranslationFacets(this.constants.facetValueTranslations, facetBuckets.buckets);
            }
        });

        // Add the Features facet group if it has buckets
        if (featuresFacetObject.buckets.length > 0) {
            this.state.filterFacets.push(featuresFacetObject);
        }

        this.state.filterFacets.sort((a, b) => {
            // Prioritize Features group
            if (a.name === 'Features' && b.name !== 'Features') {
                return -1;
            }
            if (b.name === 'Features' && a.name !== 'Features') {
                return 1;
            }

            // Then sort by bucket count, faceted products, and name
            if (a.buckets.length !== b.buckets.length) {
                return b.buckets.length - a.buckets.length;
            } if (a.facetedProducts !== b.facetedProducts) {
                return b.facetedProducts - a.facetedProducts;
            }
            return a.name.localeCompare(b.name);

        });

        this.state.filterFacets = this.state.filterFacets.slice(0, this.constants.maxFacets);
    };

    initDynamicFacets = (facets) => {
        facets.forEach((facet) => {
            if (facet.unique_values.buckets && typeof facet.unique_values.buckets[Symbol.iterator] === 'function') {
                const facetObject = {
                    name: facet.key,
                    buckets: [],
                    facetedProducts: 0,
                    type: 'checkbox',
                };
                facet.unique_values.buckets.forEach((bucket) => {
                    if (bucket.doc_count !== 0) {
                        facetObject.buckets.push({
                            key: bucket.key,
                            count: bucket.doc_count,
                        });

                        facetObject.facetedProducts += bucket.doc_count;
                    }
                });
                if (facetObject.buckets.length > 1) {
                    this.state.filterFacets.push(facetObject);
                }
            }
        });
    };

    // initNumericFacets = (facets) => {
    //     if (!facets) {
    //         return;
    //     }
    //     for (const facet of facets) {
    //         if (facet.unique_values.buckets && typeof facet.unique_values.buckets[Symbol.iterator] === 'function') {
    //             const facetObject = {
    //                 name: `range-input-${facet.key}`,
    //                 buckets: [],
    //                 facetedProducts: 0,
    //                 type: 'slider',
    //                 min: Number.MAX_SAFE_INTEGER,
    //                 max: Number.MIN_SAFE_INTEGER,
    //                 unit: '',
    //             };
    //             for (const bucket of facet.unique_values.buckets) {
    //                 if (bucket.filtered_docs.doc_count === 0) {
    //                     continue;
    //                 }
    //                 if (bucket.filtered_docs.unit_symbols.buckets.length > 1 || (facet.unit !== '' && bucket.filtered_docs.unit_symbols.buckets.length === 1 && bucket.filtered_docs.unit_symbols.buckets[0].key !== facet.unit)) {
    //                     facetObject.unit = null;
    //                     break;
    //                 } else if (bucket.filtered_docs.unit_symbols.buckets.length === 1) {
    //                     facetObject.unit = bucket.filtered_docs.unit_symbols.buckets[0].key;
    //                 }
    //                 facetObject.buckets.push({
    //                     key: bucket.key,
    //                     count: bucket.doc_count,
    //                 });
    //                 facetObject.min = Math.min(facetObject.min, bucket.key);
    //                 facetObject.max = Math.max(facetObject.max, bucket.key);
    //                 facetObject.facetedProducts += bucket.doc_count;
    //             }
    //             if (facetObject.buckets.length > 1 && facetObject.min !== Number.MAX_SAFE_INTEGER && facetObject.max !== Number.MIN_SAFE_INTEGER && facetObject.min !== facetObject.max && facetObject.unit !== null) {
    //                 this.state.filterFacets.push(facetObject);
    //             }
    //         }
    //     }
    // };

    // fillSlider = (from, to, sliderColor, rangeColor, controlSlider) => {
    //     const rangeDistance = to.max-to.min;
    //     const fromPosition = from.value - to.min;
    //     const toPosition = to.value - to.min;
    //     controlSlider.style.setProperty('--slider-fill-gradient', `linear-gradient(
    //       to right,
    //       ${sliderColor} 0%,
    //       ${sliderColor} ${(fromPosition)/(rangeDistance)*100}%,
    //       ${rangeColor} ${((fromPosition)/(rangeDistance))*100}%,
    //       ${rangeColor} ${(toPosition)/(rangeDistance)*100}%,
    //       ${sliderColor} ${(toPosition)/(rangeDistance)*100}%,
    //       ${sliderColor} 100%)`);
    // };

    updateFacetCounts = async (facets) => {
        if (!facets) {
            return;
        }
        // Disable all checkboxes by default except those in a group with a checked checkbox
        this.elements.filterList.querySelectorAll(`.${componentName}__filter-checkbox-container`).forEach((checkbox) => {
            if (checkbox.closest(`.${componentName}__filter-content`) && !checkbox.closest(`.${componentName}__filter-content`).querySelector(`.${componentName}__filter-checkbox:checked`) && checkbox.querySelector(`.${componentName}__filter-checkbox`)) {
                checkbox.querySelector(`.${componentName}__filter-checkbox`).disabled = !checkbox.querySelector(`.${componentName}__filter-checkbox`).checked;
                if (checkbox.querySelector(`.${componentName}__filter-checkbox-count`)) {
                    checkbox.querySelector(`.${componentName}__filter-checkbox-count`).textContent = '(0)';
                }
            }
        });
        Object.entries(facets).forEach(([facetName, facetBuckets]) => {
            if (facetName === 'classification_features' && this.constants.language === 'en') {
                this.updateDynamicFacetCounts(facetBuckets.buckets);
                return;
            } if (facetName === 'translation_classification' && this.constants.language !== 'en') {
                this.updateDynamicFacetCounts(facetBuckets.buckets);
                return;
            } if (facetName === 'primary_category_filter') {
                facetName = 'Product Category';
            }

            // Handle Features facet group specially
            if (facetName === 'salesOrg_repairable' || facetName === 'registerable' || facetName === 'pim_baba' || facetName === 'sustainability' || facetName === 'ecodesign' || facetName === 'salesOrg_preferredAvailability') {
                const featuresFacetGroup = this.elements.filterList.querySelector(`.${componentName}__filter-group[data-facet-name="Features"]`);
                if (featuresFacetGroup && (!facetBuckets.buckets || !facetBuckets.buckets.length)) {
                    let displayKey = '';
                    if (facetName === 'salesOrg_repairable') {
                        displayKey = this.constants.featureFacets.repairable.name;
                    } else if (facetName === 'registerable') {
                        displayKey = this.constants.featureFacets.registrable.name;
                    } else if (this.constants.countryCode === 'US' && facetName === 'pim_baba') {
                        displayKey = this.constants.featureFacets.pimBaba.name;
                    } else if (facetName === 'sustainability') {
                        displayKey = this.constants.featureFacets.dpp.name;
                    } else if (facetName === 'ecodesign') {
                        displayKey = this.constants.featureFacets.ecodesign.name;
                    }
                    if (displayKey) {
                        const bucketCheckbox = featuresFacetGroup.querySelector(`.${componentName}__filter-checkbox-container[data-bucket-name="${encodeURIComponent(displayKey)}"]`);
                        if (bucketCheckbox) {
                            bucketCheckbox.querySelector(`.${componentName}__filter-checkbox-count`).textContent = '(0)';
                            bucketCheckbox.querySelector(`.${componentName}__filter-checkbox`).disabled = true;
                        }
                    } else if (facetName === 'preferredProducts') {
                        const preferredProductsCheckbox = featuresFacetGroup.querySelector(`.${componentName}__filter-checkbox-container:has(.${componentName}__filter-checkbox[name="preferredProducts"])`);
                        if (preferredProductsCheckbox) {
                            preferredProductsCheckbox.querySelector(`.${componentName}__filter-checkbox-count`).textContent = '(0)';
                            preferredProductsCheckbox.querySelector(`.${componentName}__filter-checkbox`).disabled = true;
                        }
                    }
                } else if (featuresFacetGroup && facetBuckets.buckets && typeof facetBuckets.buckets[Symbol.iterator] === 'function') {
                    facetBuckets.buckets.forEach((bucket) => {
                        let displayKey = '';
                        if (facetName === 'salesOrg_repairable' && bucket.key === 'REPAIRABLE') {
                            displayKey = this.constants.featureFacets.repairable.name;
                        } else if (facetName === 'registerable' && bucket.key === 1) {
                            displayKey = this.constants.featureFacets.registrable.name;
                        } else if (this.constants.countryCode === 'US' && facetName === 'pim_baba' && bucket.key === 'PIM_BABA') {
                            displayKey = this.constants.featureFacets.pimBaba.name;
                        } else if (facetName === 'sustainability' && bucket.key === 'sustainability') {
                            displayKey = this.constants.featureFacets.dpp.name;
                        } else if (facetName === 'ecodesign' && bucket.key === 'ecodesign') {
                            displayKey = this.constants.featureFacets.ecodesign.name;
                        }
                        if (displayKey) {
                            const bucketCheckbox = featuresFacetGroup.querySelector(`.${componentName}__filter-checkbox-container[data-bucket-name="${encodeURIComponent(displayKey)}"]`);
                            if (bucketCheckbox) {
                                bucketCheckbox.querySelector(`.${componentName}__filter-checkbox-count`).textContent = `(${bucket.count})`;
                                bucketCheckbox.querySelector(`.${componentName}__filter-checkbox`).disabled = bucket.count === 0;
                            }
                        } else if (facetName === 'salesOrg_preferredAvailability' && bucket.key === 1) {
                            const preferredProductsCheckbox = featuresFacetGroup.querySelector(`.${componentName}__filter-checkbox-container:has(.${componentName}__filter-checkbox[name="preferredProducts"])`);
                            if (preferredProductsCheckbox) {
                                preferredProductsCheckbox.querySelector(`.${componentName}__filter-checkbox-count`).textContent = `(${bucket.count})`;
                                preferredProductsCheckbox.querySelector(`.${componentName}__filter-checkbox`).disabled = bucket.count === 0;
                            }
                        }
                    });
                }
                return;
            }

            const facetGroup = this.elements.filterList.querySelector(`.${componentName}__filter-group[data-facet-name="${facetName}"]`);
            if (facetGroup && facetBuckets.buckets && typeof facetBuckets.buckets[Symbol.iterator] === 'function') {
                facetBuckets.buckets.forEach((bucket) => {
                    const bucketCheckbox = facetGroup.querySelector(`.${componentName}__filter-checkbox-container[data-bucket-name="${encodeURIComponent(bucket.key)}"]`);
                    if (bucketCheckbox) {
                        bucketCheckbox.querySelector(`.${componentName}__filter-checkbox-count`).textContent = `(${bucket.count})`;
                        bucketCheckbox.querySelector(`.${componentName}__filter-checkbox`).disabled = bucket.count === 0;
                    }
                });
            }
        });
    };

    updateDynamicFacetCounts = (facets) => {
        facets.forEach((facet) => {
            const facetGroup = this.elements.filterList.querySelector(`.${componentName}__filter-group[data-facet-name="${facet.key}"]`);
            if (facetGroup && facet.unique_values.buckets && typeof facet.unique_values.buckets[Symbol.iterator] === 'function') {
                facet.unique_values.buckets.forEach((bucket) => {
                    const bucketCheckbox = facetGroup.querySelector(`.${componentName}__filter-checkbox-container[data-bucket-name="${encodeURIComponent(bucket.key)}"]`);
                    if (bucketCheckbox) {
                        bucketCheckbox.querySelector(`.${componentName}__filter-checkbox-count`).textContent = `(${bucket.doc_count})`;
                        bucketCheckbox.querySelector(`.${componentName}__filter-checkbox`).disabled = bucket.doc_count === 0;
                    }
                });
            }
        });
    };

    translateFacet = (facetString, type) => {
        if (type === 'name') {
            return this.constants.facetNameTranslations[facetString] || this.constants.i18n[facetString] || facetString;
        } if (type === 'value') {
            return this.constants.facetValueTranslations[facetString] || this.constants.i18n[facetString] || facetString;
        }
        return this.constants.i18n[facetString] || facetString;
    };

    fillTranslationFacets = (translationDictionary, buckets) => {
        if (!buckets) {
            return;
        }
        buckets.forEach((bucket) => {
            if (bucket.unique_values.buckets && typeof bucket.unique_values.buckets[Symbol.iterator] === 'function' && bucket.unique_values.buckets.length > 0) {
                translationDictionary[bucket.key] = bucket.unique_values.buckets[0].key;
            }
        });
    };

    createProductElement = (product) => {
        const productElement = this.elements.productTemplate.cloneNode(true);
        productElement.classList.remove(`${componentName}__product-template`);
        productElement.setAttribute('data-product-id', product.catalogNumber);
        if ((Object.hasOwn(product, `salesOrg_${this.constants.countryCode.toLowerCase()}_preferredAvailability`) && !product[`salesOrg_${this.constants.countryCode.toLowerCase()}_preferredAvailability`])
            || (!Object.hasOwn(product, `salesOrg_${this.constants.countryCode.toLowerCase()}_preferredAvailability`) && !product.salesOrg_us_preferredAvailability)) {
            productElement.querySelector(`.${componentName}__product-best-selling-tag`).remove();
        }
        productElement.querySelector(`.${componentName}__product-image`).addEventListener('error', () => {
            const image = productElement.querySelector(`.${componentName}__product-image`);
            const backupSrc = backupImage.replaceAll('{sku}', product.catalogNumber);
            const defaultSrc = this.getDefaultImage();
            const currentSrc = image.getAttribute('src');

            if (currentSrc === backupSrc) {
                image.setAttribute('src', defaultSrc);
                return;
            }
            if (currentSrc === defaultSrc) {
                return;
            }
            image.setAttribute('src', backupSrc);

        });
        productElement.querySelector(`.${componentName}__product-image`).setAttribute('src', (product.picture_url ? product.picture_url : this.getDefaultImage()));
        productElement.querySelector(`.${componentName}__product-image`).setAttribute('alt', `${product.catalogNumber} ${this.getTranslatableProductField(product, 'names', 'names_value', '', this.constants.language)} product image`);
        const locale = document.documentElement.lang ? document.documentElement.lang.toLocaleLowerCase() : 'en-us';
        const productLink = `${window.location.origin}${this.constants.app.toLowerCase() !== 'ss' && !window.location.origin.endsWith('.com.cn') ? `/${locale}` : ''}${productDetailPath.replace('{catalogNumber}', this.encodeCatalogNumber(product.catalogNumber))}`;
        productElement.querySelectorAll(`.${componentName}__product-link`).forEach((link) => {
            link.setAttribute('href', productLink);
        });
        this.addTextContentOrRemove(productElement.querySelector(`.${componentName}__product-title`), this.getTranslatableProductField(product, 'names', 'names_value', '', this.constants.language));
        this.addTextContentOrRemove(productElement.querySelector(`.${componentName}__product-catalog-number`), product.catalogNumber);
        this.addTextContentOrRemove(productElement.querySelector(`.${componentName}__product-lifecycle-status-text`), this.constants.i18n[this.toTitleCase(product.productLifeCycleStatus?.replaceAll('_', ' '))] || product.productLifeCycleStatus?.toLowerCase().replaceAll('_', ' '));
        productElement.querySelector(`.${componentName}__product-lifecycle-status-dot`)?.classList.add(`${componentName}__product-lifecycle-status-dot--${product.productLifeCycleStatus ? product.productLifeCycleStatus.toLowerCase() : 'hidden'}`);
        let productDescription = this.getTranslatableProductField(product, 'Rdescription', 'R_description', '', this.constants.language);
        if (!productDescription) {
            productDescription = this.getTranslatableProductField(product, 'technicalDescription', 'technicalDescription_value', '', this.constants.language);
        }
        this.addTextContentOrRemove(productElement.querySelector(`.${componentName}__product-description`), productDescription);
        productElement.querySelector(`.${componentName}__product-bom-link`).setAttribute('href', addToBomEndpoint.replace('{catalogNumber}', product.catalogNumber));
        if (product.productConfigLink) {
            productElement.querySelector(`.${componentName}__product-configure-link`).setAttribute('href', product.productConfigLink);
        } else {
            productElement.querySelector(`.${componentName}__product-configure-link`).remove();
        }

        const compareCheckbox = productElement.querySelector(`.${componentName}__product-compare-checkbox`);
        compareCheckbox.setAttribute('id', `${product.catalogNumber}-compare`);
        productElement.querySelector(`.${componentName}__product-compare-label`).setAttribute('for', `${product.catalogNumber}-compare`);
        if (this.state.userCompareData.includes(product.catalogNumber)) {
            compareCheckbox.checked = true;
        }
        compareCheckbox.setAttribute('data-sku', product.catalogNumber);
        compareCheckbox.addEventListener('change', async (event) => {
            await this.compareCheckboxClick(event);
        });
        compareCheckbox.addEventListener('keydown', async (event) => {
            if (event.key === 'Enter') {
                await compareCheckbox.click();
            }
        });

        productElement.querySelector(`.${componentName}__product-popup-chevron`).addEventListener('click', () => {
            if (productElement.classList.contains('popup-active')) {
                productElement.classList.remove('popup-active');
            } else {
                productElement.classList.add('popup-active');
            }
        });
        return productElement;
    };

    addTextContentOrRemove = (element, textContent) => {
        if (textContent) {
            element.textContent += textContent;
        } else {
            element.remove();
        }
    };

    numberWithCommas = (x) => {
        if (x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        }
        return '';
    };

    updatePageIndex = (pageIndex) => {
        this.state.pageIndex = pageIndex;
    };

    handlePaginationFormSubmit = async (event) => {
        event.preventDefault();
        if (event.submitter?.name === 'input-submitter') {
            const inputEl = this.elements.paginationForm.querySelector(`.${componentName}__pagination-input`);
            if (!inputEl.validity.valid) return;
            this.updatePageIndex(Number(inputEl.value) - 1);
        }
        this.showSpinner();
        this.elements.paginationForm.querySelector(`.${componentName}__pagination-button[name="prev"]`).setAttribute('disabled', true);
        this.elements.paginationForm.querySelector(`.${componentName}__pagination-button[name="next"]`).setAttribute('disabled', true);
        this.elements.paginationForm.querySelector(`.${componentName}__pagination-input`).setAttribute('disabled', true);
        this.elements.paginationForm.querySelector(`.${componentName}__pagination-input`).value = this.state.pageIndex + 1;
        if (this.constants.listType === 'category') {
            let index = 0;
            const products = this.elements.subcategoryGrid.querySelectorAll(`.${componentName}__product`);

            for (let i = 0; i < products.length; i += 1) {
                const product = products[i];

                if (!product.classList.contains('filtered-out')) {
                    if (
                        index < (this.state.resultsPerPage * this.state.pageIndex)
                        || index >= (this.state.resultsPerPage * (this.state.pageIndex + 1))
                    ) {
                        product.classList.add('hidden');
                    } else {
                        product.classList.remove('hidden');
                    }

                    index += 1;
                }
            }
        } else {
            const productResults = await this.getProducts();
            this.state.productList = productResults.dataList;
            this.elements.productGrid.querySelectorAll(`.${componentName}__product`).forEach((product) => {
                if (!product.classList.contains(`${componentName}__product-template`)) {
                    product.remove();
                }
            });
            this.state.productList.forEach((product) => {
                this.elements.productGrid.appendChild(this.createProductElement(product));
            });
        }
        [...this.element.querySelectorAll(`.${componentName}__pagination-start-index`)].forEach((startIndex) => {
            startIndex.textContent = (this.state.pageIndex * this.state.resultsPerPage) + 1;
        });
        [...this.element.querySelectorAll(`.${componentName}__pagination-end-index`)].forEach((endIndex) => {
            endIndex.textContent = Math.min((this.state.pageIndex + 1) * this.state.resultsPerPage, this.state.totalResults);
        });
        this.initTooltips();
        this.hideSpinner();
        if (this.state.pageIndex < this.state.totalPages - 1) {
            this.elements.paginationForm.querySelector(`.${componentName}__pagination-button[name="next"]`).removeAttribute('disabled');
        }
        if (this.state.pageIndex > 0) {
            this.elements.paginationForm.querySelector(`.${componentName}__pagination-button[name="prev"]`).removeAttribute('disabled');
        }
        this.elements.paginationForm.querySelector(`.${componentName}__pagination-input`).removeAttribute('disabled');
    };

    handleResultsPerPageChange = async (event) => {
        this.showSpinner();
        this.elements.paginationForm.querySelector(`.${componentName}__pagination-button[name="prev"]`).setAttribute('disabled', true);
        this.elements.paginationForm.querySelector(`.${componentName}__pagination-button[name="next"]`).setAttribute('disabled', true);
        this.elements.paginationForm.querySelector(`.${componentName}__pagination-input`).setAttribute('disabled', true);
        this.state.resultsPerPage = parseInt(event.target.value, 10);
        this.state.pageIndex = 0;
        this.state.totalPages = Math.ceil(this.state.totalResults / this.state.resultsPerPage);
        if (this.constants.listType === 'category') {
            let index = 0;
            const products = this.elements.subcategoryGrid.querySelectorAll(`.${componentName}__product`);

            for (let i = 0; i < products.length; i += 1) {
                const product = products[i];

                if (!product.classList.contains('filtered-out')) {
                    if (
                        index < (this.state.resultsPerPage * this.state.pageIndex)
                        || index >= (this.state.resultsPerPage * (this.state.pageIndex + 1))
                    ) {
                        product.classList.add('hidden');
                    } else {
                        product.classList.remove('hidden');
                    }

                    index += 1;
                }
            }

        } else {
            const productResults = await this.getProducts();
            this.state.productList = productResults.dataList;
            this.elements.productGrid.querySelectorAll(`.${componentName}__product`).forEach((product) => {
                if (!product.classList.contains(`${componentName}__product-template`)) {
                    product.remove();
                }
            });
            this.state.productList.forEach((product) => {
                this.elements.productGrid.appendChild(this.createProductElement(product));
            });
        }
        this.elements.paginationForm.querySelector(`.${componentName}__pagination-input`).value = 1;
        [...this.element.querySelectorAll(`.${componentName}__pagination-start-index`)].forEach((startIndex) => {
            startIndex.textContent = 1;
        });
        [...this.element.querySelectorAll(`.${componentName}__pagination-end-index`)].forEach((endIndex) => {
            endIndex.textContent = Math.min(this.state.resultsPerPage, this.state.totalResults);
        });
        this.elements.paginationForm.querySelector('span[data-name="page-count"]').textContent = this.state.totalPages;
        this.elements.paginationForm.querySelector(`.${componentName}__pagination-input`).max = this.state.totalPages;
        this.initTooltips();
        this.hideSpinner();
        if (this.state.pageIndex < this.state.totalPages - 1) {
            this.elements.paginationForm.querySelector(`.${componentName}__pagination-button[name="next"]`).removeAttribute('disabled');
        }
        this.elements.paginationForm.querySelector(`.${componentName}__pagination-input`).removeAttribute('disabled');
        this.elements.paginationForm.querySelector(`.${componentName}__pagination-input`).setAttribute('max', this.state.totalPages);
    };

    handleProductSortChange = async (sortValue) => {
        this.showSpinner();
        this.elements.paginationForm.querySelector(`.${componentName}__pagination-button[name="prev"]`).setAttribute('disabled', true);
        this.elements.paginationForm.querySelector(`.${componentName}__pagination-button[name="next"]`).setAttribute('disabled', true);
        this.elements.paginationForm.querySelector(`.${componentName}__pagination-input`).setAttribute('disabled', true);
        this.state.pageIndex = 0;
        this.state.totalPages = Math.ceil(this.state.totalResults / this.state.resultsPerPage);
        this.state.sortBy = sortValue;
        if (this.constants.listType === 'category') {
            let sortedProductElements = [];
            if (this.state.sortBy === 'alphaSort--asc') {
                sortedProductElements = [...this.elements.subcategoryGrid.querySelectorAll(`.${componentName}__product`)].sort(this.sortProductElementsByTitle);
            } else if (this.state.sortBy === 'alphaSort--desc') {
                sortedProductElements = [...this.elements.subcategoryGrid.querySelectorAll(`.${componentName}__product`)].sort(this.sortProductElementsByTitle).reverse();
            }
            this.elements.subcategoryGrid.innerHTML = '';
            sortedProductElements.forEach((product) => {
                this.elements.subcategoryGrid.appendChild(product);
            });
            let index = 0;

            for (let i = 0; i < sortedProductElements.length; i += 1) {
                const product = sortedProductElements[i];

                if (!product.classList.contains('filtered-out')) {
                    if (index >= this.state.resultsPerPage) {
                        product.classList.add('hidden');
                    } else {
                        product.classList.remove('hidden');
                    }

                    index += 1;
                }
            }
        } else {
            const productResults = await this.getProducts();
            this.state.productList = productResults.dataList;
            this.elements.productGrid.querySelectorAll(`.${componentName}__product`).forEach((product) => {
                if (!product.classList.contains(`${componentName}__product-template`)) {
                    product.remove();
                }
            });
            this.state.productList.forEach((product) => {
                this.elements.productGrid.appendChild(this.createProductElement(product));
            });
        }
        this.elements.paginationForm.querySelector(`.${componentName}__pagination-input`).value = 1;
        [...this.element.querySelectorAll(`.${componentName}__pagination-start-index`)].forEach((startIndex) => {
            startIndex.textContent = 1;
        });
        [...this.element.querySelectorAll(`.${componentName}__pagination-end-index`)].forEach((endIndex) => {
            endIndex.textContent = Math.min(this.state.resultsPerPage, this.state.totalResults);
        });
        this.elements.paginationForm.querySelector('span[data-name="page-count"]').textContent = this.state.totalPages;
        this.initTooltips();
        this.hideSpinner();
        if (this.state.pageIndex < this.state.totalPages - 1) {
            this.elements.paginationForm.querySelector(`.${componentName}__pagination-button[name="next"]`).removeAttribute('disabled');
        }
        this.elements.paginationForm.querySelector(`.${componentName}__pagination-input`).removeAttribute('disabled');
        this.elements.paginationForm.querySelector(`.${componentName}__pagination-input`).setAttribute('max', this.state.totalPages);
    };

    sortProductElementsByTitle = (productA, productB) => {
        const productAName = productA.querySelector(`.${componentName}__product-title`).textContent.toLowerCase();
        const productBName = productB.querySelector(`.${componentName}__product-title`).textContent.toLowerCase();
        if (productAName < productBName) {
            return -1;
        }
        if (productAName > productBName) {
            return 1;
        }
        return 0;
    };

    handleTextSearchChange = async () => {
        this.showSpinner();
        this.elements.paginationForm.querySelector(`.${componentName}__pagination-button[name="prev"]`).setAttribute('disabled', true);
        this.elements.paginationForm.querySelector(`.${componentName}__pagination-button[name="next"]`).setAttribute('disabled', true);
        this.elements.paginationForm.querySelector(`.${componentName}__pagination-input`).setAttribute('disabled', true);
        this.state.pageIndex = 0;
        this.state.totalPages = Math.ceil(this.state.totalResults / this.state.resultsPerPage);
        this.elements.filterClearAll.hidden = (this.elements.filterForm.querySelectorAll('input[type="checkbox"]:checked').length === 0 && (this.state.textSearch === ''));

        if (this.constants.listType === 'category') {
            const filteredProductElements = [...this.elements.subcategoryGrid.querySelectorAll(`.${componentName}__product`)].filter((product) => (product.querySelector(`.${componentName}__product-title`).textContent.toLowerCase().includes(this.state.textSearch.toLowerCase()) || (product.querySelector(`.${componentName}__product-description`) && product.querySelector(`.${componentName}__product-description`).textContent.toLowerCase().includes(this.state.textSearch.toLowerCase()))));
            const products = this.elements.subcategoryGrid.querySelectorAll(`.${componentName}__product`);
            let index = 0;

            for (let i = 0; i < products.length; i += 1) {
                const product = products[i];
                product.classList.add('filtered-out');

                if (filteredProductElements.includes(product)) {
                    product.classList.remove('filtered-out');

                    if (index >= this.state.resultsPerPage) {
                        product.classList.add('hidden');
                    }else {
                        product.classList.remove('hidden');
                    }

                    index += 1;
                }
            }

            this.state.totalResults = filteredProductElements.length;
            this.state.totalPages = Math.ceil(this.state.totalResults / this.state.resultsPerPage);
            this.updateCategoryFacetCounts();
        } else {
            const productResults = await this.getProducts();
            this.state.productList = productResults.dataList;
            this.state.totalResults = productResults.totalNumber;
            this.state.totalPages = Math.ceil(this.state.totalResults / this.state.resultsPerPage);
            await this.updateFacetCounts(productResults.facets);
            this.elements.productGrid.querySelectorAll(`.${componentName}__product`).forEach((product) => {
                if (!product.classList.contains(`${componentName}__product-template`)) {
                    product.remove();
                }
            });
            this.state.productList.forEach((product) => {
                this.elements.productGrid.appendChild(this.createProductElement(product));
            });
        }
        this.elements.paginationForm.querySelector(`.${componentName}__pagination-input`).value = 1;
        [...this.element.querySelectorAll(`.${componentName}__pagination-start-index`)].forEach((startIndex) => {
            startIndex.textContent = 1;
        });
        [...this.element.querySelectorAll(`.${componentName}__pagination-end-index`)].forEach((endIndex) => {
            endIndex.textContent = Math.min(this.state.resultsPerPage, this.state.totalResults);
        });
        [...this.element.querySelectorAll(`.${componentName}__pagination-total-count`)].forEach((totalCount) => {
            totalCount.textContent = this.state.totalResults;
        });
        this.elements.paginationForm.querySelector('span[data-name="page-count"]').textContent = this.state.totalPages;
        this.initTooltips();
        this.hideSpinner();
        if (this.state.pageIndex < this.state.totalPages - 1) {
            this.elements.paginationForm.querySelector(`.${componentName}__pagination-button[name="next"]`).removeAttribute('disabled');
        }
        this.elements.paginationForm.querySelector(`.${componentName}__pagination-input`).removeAttribute('disabled');
        this.elements.paginationForm.querySelector(`.${componentName}__pagination-input`).setAttribute('max', this.state.totalPages);
    };

    handleProductFilterChange = async () => {
        this.showSpinner();

        const filterFormData = new FormData(this.elements.filterForm);
        this.state.filters = {};
        Array.from(filterFormData).forEach(([key, value]) => {
            if (value !== '' && key !== 'mobileSort' && key !== 'ra-product-search-input') {
                if (key.startsWith('range-input-')) {
                    // const rangeInput = this.elements.filterForm.querySelector(`input[name="${key}"]`).closest(`.${componentName}__filter-slider-container`);
                    // if (this.rangeInputEmpty(rangeInput)) {
                    //     continue;
                    // }
                    // key = key.split('-').slice(0, key.split('-').length - 1).join('-');
                }
                if (this.state.filters[key]) {
                    this.state.filters[key].push(value);
                } else {
                    this.state.filters[key] = [value];
                }
            }
        });

        this.elements.filterClearAll.hidden = (this.elements.filterForm.querySelectorAll('input[type="checkbox"]:checked').length === 0 && (this.state.textSearch === ''));
        this.elements.paginationForm.querySelector(`.${componentName}__pagination-button[name="prev"]`).setAttribute('disabled', true);
        this.elements.paginationForm.querySelector(`.${componentName}__pagination-button[name="next"]`).setAttribute('disabled', true);
        this.elements.paginationForm.querySelector(`.${componentName}__pagination-input`).setAttribute('disabled', true);
        this.state.pageIndex = 0;

        if (this.constants.listType === 'category') {
            const filteredProductElements = [];
            this.elements.subcategoryGrid.querySelectorAll(`.${componentName}__product`).forEach((product) => {
                let productFilteredOut = false;
                const isProductDiscontinued = product.classList.contains('discontinued');
                if (isProductDiscontinued && (!this.state.filters.discontinued || !this.state.filters.discontinued.includes('true'))) {
                    productFilteredOut = true;
                }
                Object.keys(this.state.filters).forEach((filter) => {
                    if (filter === 'discontinued') {
                        return;
                    }
                    const metadataElement = product.querySelector(`.${componentName}__product-filter[data-name="${filter}"]`);
                    let filterValueFound = false;
                    this.state.filters[filter].forEach((filterValue) => {
                        if (metadataElement && metadataElement.querySelector(`.${componentName}__product-filter-values[data-value="${filterValue}"]`)) {
                            filterValueFound = true;
                        }
                    });
                    if (!filterValueFound) {
                        productFilteredOut = true;
                    }
                });
                if (!productFilteredOut) {
                    filteredProductElements.push(product);
                }
            });

            const products = this.elements.subcategoryGrid.querySelectorAll(`.${componentName}__product`);
            let index = 0;

            for (let i = 0; i < products.length; i += 1) {
                const product = products[i];
                const isFiltered = filteredProductElements.includes(product);

                product.classList.toggle('filtered-out', !isFiltered);

                if (isFiltered) {
                    product.classList.toggle(
                        'hidden',
                        index >= this.state.resultsPerPage
                    );
                    index += 1;
                }
            }

            this.state.totalResults = filteredProductElements.length;
            this.updateCategoryFacetCounts();
        } else {
            const productResults = await this.getProducts();
            this.state.productList = productResults.dataList;
            this.state.totalResults = productResults.totalNumber;
            await this.updateFacetCounts(productResults.facets);
            this.elements.productGrid.querySelectorAll(`.${componentName}__product`).forEach((product) => {
                if (!product.classList.contains(`${componentName}__product-template`)) {
                    product.remove();
                }
            });
            this.state.productList.forEach((product) => {
                this.elements.productGrid.appendChild(this.createProductElement(product));
            });
        }

        this.state.totalPages = Math.ceil(this.state.totalResults / this.state.resultsPerPage);
        this.elements.paginationForm.querySelector(`.${componentName}__pagination-input`).value = 1;
        [...this.element.querySelectorAll(`.${componentName}__pagination-start-index`)].forEach((startIndex) => {
            startIndex.textContent = 1;
        });
        [...this.element.querySelectorAll(`.${componentName}__pagination-end-index`)].forEach((endIndex) => {
            endIndex.textContent = Math.min(this.state.resultsPerPage, this.state.totalResults);
        });
        [...this.element.querySelectorAll(`.${componentName}__pagination-total-count`)].forEach((totalCount) => {
            totalCount.textContent = this.state.totalResults;
        });
        this.elements.paginationForm.querySelector('span[data-name="page-count"]').textContent = this.state.totalPages;
        this.initTooltips();
        this.hideSpinner();
        if (this.state.pageIndex < this.state.totalPages - 1) {
            this.elements.paginationForm.querySelector(`.${componentName}__pagination-button[name="next"]`).removeAttribute('disabled');
        }
        this.elements.paginationForm.querySelector(`.${componentName}__pagination-input`).removeAttribute('disabled');
        this.elements.paginationForm.querySelector(`.${componentName}__pagination-input`).setAttribute('max', this.state.totalPages);

        this.rerenderFacetBuckets();
    };

    rerenderFacetBuckets = () => {
        this.elements.filterContainer.querySelectorAll(`.${componentName}__filter-group`).forEach((group) => {
            const list = group.querySelector('.product-family-list__filter-content');
            this.reorderSelectedToTop(list);
        });
    };

    // Reorder function for this list
    reorderSelectedToTop = (list) => {
        const items = Array.from(list.children);
        items.sort((a, b) => {
            const aChecked = a.querySelector('input[type="checkbox"]')?.checked;
            const bChecked = b.querySelector('input[type="checkbox"]')?.checked;

            // Selected first
            if (aChecked && !bChecked) return -1;
            if (!aChecked && bChecked) return 1;

            // If both are the same (selected or unselected), preserve original order
            return Number(a.dataset.originalIndex) - Number(b.dataset.originalIndex);
        });

        // Move elements in new order
        return items.forEach((item) => list.appendChild(item));
    };

    createFilterChip = (filterCategory, filterValue, filterLabel) => {
        const { chipContainer } = this.elements;
        const chipTemplate = chipContainer.querySelector(`.${componentName}__chip-template`);
        const chip = chipTemplate.cloneNode(true);
        chip.classList.remove(`${componentName}__chip-template`);
        chip.querySelector(`.${componentName}__chip-text`).textContent = filterLabel;
        chip.setAttribute('data-name', filterCategory);
        chip.setAttribute('data-value', filterValue);
        chip.addEventListener('click', () => this.handleFilterChipClick(chip));
        chipContainer.appendChild(chip);
    };

    handleFilterChipClick = (chip) => {
        const filterCategory = chip.dataset.name;
        const filterValue = chip.dataset.value;
        if (filterCategory === 'textSearch') {
            this.elements.textSearchInput.value = '';
            this.state.textSearch = '';
            this.handleTextSearchChange();
        } else {
            const checkbox = this.elements.filterForm.querySelector(`input[name="${filterCategory}"][value="${filterValue}"]`);
            checkbox.click();
        }
        chip.remove();
    };

    // rangeInputsEmpty = () => {
    //     let rangeInputsEmpty = true;
    //     const rangeInputs = this.elements.filterForm.querySelectorAll(`.${componentName}__filter-slider-container`);
    //     rangeInputs.forEach((rangeInput) => {
    //         if (!rangeInput.classList.contains(`${componentName}__filter-slider-container-template`)) {
    //             rangeInputsEmpty = this.rangeInputEmpty(rangeInput) && rangeInputsEmpty;
    //         }
    //     });
    //     return rangeInputsEmpty;
    // };

    // rangeInputEmpty = (rangeInput) => {
    //     const rangeInput1 = rangeInput.querySelector(`.${componentName}__filter-slider-range[data-index="0"]`);
    //     const rangeInput2 = rangeInput.querySelector(`.${componentName}__filter-slider-range[data-index="1"]`);
    //     if ((rangeInput1.value !== rangeInput1.min && rangeInput1.value != rangeInput1.max) || (rangeInput2.value != rangeInput2.min && rangeInput2.value != rangeInput2.max) || (rangeInput1.value == rangeInput2.value)) {
    //         return false;
    //     }
    //     return true;
    // };

    toTitle = (label) => {
        // convert all caps to title case
        label = label.replace(/([A-Z]{2,})/g, (str) => str.toLowerCase());
        // convert to title case
        label = label.replace(/([A-Z])/g, ' $1').replace(/^./, (str) => str.toUpperCase());
        return label;
    };

    toTitleCase = (label) => label.split(' ').map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');

    compareCheckboxClick = async (event) => {
        const compareButtons = document.querySelectorAll(`.${componentName}__product-compare-checkbox`);
        const compareButton = event.target;
        const catalogNumber = compareButton.dataset.sku;
        if (compareButton.checked) {
            compareButton.setAttribute('data-var', 'checked');
            if (!this.state.userCompareData.includes(catalogNumber) && this.state.userCompareData.length < 4) {
                this.state.userCompareData.push(catalogNumber);
                window.localStorage.setItem('userCompareData', this.state.userCompareData.join(', '));
                if (this.state.userCompareData.length === 4) {
                    compareButtons.forEach((button) => {
                        if (!this.state.userCompareData.includes(button.dataset.sku)) {
                            button.disabled = true;
                        }
                    });
                }
            }
        } else {
            compareButton.setAttribute('data-var', 'unchecked');
            let index = 0;
            this.elements.compareItems.forEach((item, itemIndex) => {
                if (item.dataset.sku === catalogNumber) {
                    index = itemIndex;
                }
            });
            this.removeCompareFrame(index, catalogNumber);
            compareButtons.forEach((button) => {
                button.disabled = false;
            });
        }
        await this.showCompareModal();
    };

    showCompareModal = async () => {
        const compareModal = document.querySelector(`.${componentName}__compare-modal`);
        const compareModalCounts = document.querySelectorAll(`.${componentName}__compare-modal-count-number`);
        compareModalCounts.forEach((count) => {
            count.innerText = count.classList.contains(`${componentName}__compare-modal-count-number--mobile`) ? `(${this.state.userCompareData.length})` : `${this.state.userCompareData.length}`;
        });
        if (this.state.userCompareData.length > 0) {
            const jsonData = await this.getCompareData(this.state.userCompareData);
            // Check if jsonData is array or object
            if (jsonData.length) {
                jsonData.sort(this.sortCompareData);
                jsonData.forEach((element, index) => {
                    this.createCompareFrame(element, index);
                });
            } else {
                this.createCompareFrame(jsonData, 0);
            }
            compareModal.classList.add('active');
        }
    };

    sortCompareData = (productA, productB) => this.state.userCompareData.indexOf(productA.catalogNumber) - this.state.userCompareData.indexOf(productB.catalogNumber);

    removeCompareFrame = (index, catalogNumber) => {
        this.state.userCompareData = this.state.userCompareData.filter((item) => item !== catalogNumber);
        window.localStorage.setItem('userCompareData', this.state.userCompareData.join(', '));
        const compareModalCounts = document.querySelectorAll(`.${componentName}__compare-modal-count-number`);
        compareModalCounts.forEach((count) => {
            count.innerText = count.classList.contains(`${componentName}__compare-modal-count-number--mobile`) ? `(${this.state.userCompareData.length})` : `${this.state.userCompareData.length}`;
        });
        this.updateCompareThumbnail(index, '');
        if (this.state.userCompareData.length === 0) {
            const compareModal = document.querySelector(`.${componentName}__compare-modal`);
            compareModal.classList.remove('active');
        }
    };

    removeAllCompareFrames = () => {
        const compareModalItems = document.querySelectorAll(`.${componentName}__compare-modal-item`);
        for (let i = 0; i < 4; i += 1) {
            compareModalItems[i].dataset.sku = '';
            compareModalItems[i].querySelector(`.${componentName}__compare-modal-item-image img`).src = '';
            compareModalItems[i].querySelector(`.${componentName}__compare-modal-item-image img`).alt = '';
            compareModalItems[i].querySelector(`.${componentName}__compare-modal-item-image`).classList.remove('active');
            compareModalItems[i].querySelector(`.${componentName}__compare-modal-item-remove`).classList.remove('active');
        }
        const compareModalCounts = document.querySelectorAll(`.${componentName}__compare-modal-count-number`);
        compareModalCounts.forEach((count) => {
            count.innerText = count.classList.contains(`${componentName}__compare-modal-count-number--mobile`) ? `(${this.state.userCompareData.length})` : `${this.state.userCompareData.length}`;
        });
        const compareModal = document.querySelector(`.${componentName}__compare-modal`);
        compareModal.classList.remove('active');
    };

    createCompareFrame = (jsonData, index) => {
        const catalogNumber = (jsonData.catalogNumber && jsonData.catalogNumber !== 'null') ? jsonData.catalogNumber : 'N/A';
        const productImage = (jsonData.picture_url && jsonData.picture_url !== 'null') ? jsonData.picture_url : this.getDefaultImage();
        this.updateCompareThumbnail(index, catalogNumber, productImage);
    };

    getCompareData = async (catalogNumbers) => {
        if (!catalogNumbers.length) {
            return [];
        }
        try {
            const locale = document.documentElement.lang ? document.documentElement.lang.toLocaleLowerCase() : 'en-us';
            const countryCode = locale.split('-')[1];
            const response = await fetch(`${productDetailServletEndpoint}?catalogNumber=${catalogNumbers.join(',')}&app=${this.constants.app}&countryCode=${countryCode}`);
            const jsonData = await response.json();
            return jsonData;
        } catch (error) {
            console.warn('Error fetching compare data', error);
            return [];
        }
    };

    updateCompareThumbnail = (index, catalogNumber, image) => {
        const compareModalItems = document.querySelectorAll(`.${componentName}__compare-modal-item`);
        if (image) {
            compareModalItems[index].dataset.sku = catalogNumber;
            compareModalItems[index].querySelector(`.${componentName}__compare-modal-item-image img`).src = image;
            compareModalItems[index].querySelector(`.${componentName}__compare-modal-item-image img`).alt = catalogNumber;
            compareModalItems[index].querySelector(`.${componentName}__compare-modal-item-image`).classList.add('active');
            compareModalItems[index].querySelector(`.${componentName}__compare-modal-item-remove`).classList.add('active');
        } else {
            compareModalItems[index].dataset.sku = '';
            compareModalItems[index].querySelector(`.${componentName}__compare-modal-item-image img`).src = '';
            compareModalItems[index].querySelector(`.${componentName}__compare-modal-item-image img`).alt = '';
            compareModalItems[index].querySelector(`.${componentName}__compare-modal-item-image`).classList.remove('active');
            compareModalItems[index].querySelector(`.${componentName}__compare-modal-item-remove`).classList.remove('active');
            if (index < 3 && [...this.elements.compareItems][index + 1].dataset.sku) {
                this.updateCompareThumbnail(index, [...this.elements.compareItems][index + 1].dataset.sku, compareModalItems[(index + 1)].querySelector(`.${componentName}__compare-modal-item-image img`).src);
                this.updateCompareThumbnail((index + 1), '');
            }
        }
    };

    refreshCompareData = async () => {
        let updatedCompareData = [];
        if (window.localStorage.getItem('userCompareData') === null) {
            updatedCompareData = this.state.userCompareData;
        } else if (window.localStorage.getItem('userCompareData').trim() === '') {
            updatedCompareData = [];
        } else {
            updatedCompareData = window.localStorage.getItem('userCompareData').split(', ');
        }
        // If data is not updated, return
        if (updatedCompareData.length === this.state.userCompareData.length && updatedCompareData.every((value) => value === this.state.userCompareData.includes(value))) {
            return;
        }
        this.state.userCompareData = updatedCompareData;
        this.removeAllCompareFrames();
        document.querySelectorAll(`.${componentName}__product-compare-checkbox`).forEach((checkbox) => {
            if (this.state.userCompareData.includes(checkbox.dataset.sku)) {
                checkbox.checked = true;
            } else {
                checkbox.checked = false;
            }
            if (this.state.userCompareData.length === 4 && !this.state.userCompareData.includes(checkbox.dataset.sku)) {
                checkbox.disabled = true;
            } else {
                checkbox.disabled = false;
            }
        });
        if (this.state.userCompareData.length > 0) {
            await this.showCompareModal();
        }
    };

    updateCategoryFacetCounts = () => {
        this.elements.filterCheckboxes.forEach((checkbox) => {
            const countElement = checkbox.closest(`.${componentName}__filter-checkbox-container`).querySelector(`.${componentName}__filter-checkbox-count`);
            let checkboxCount = 0;
            if ((checkbox.closest(`.${componentName}__filter-content`) && checkbox.closest(`.${componentName}__filter-content`).querySelector(`.${componentName}__filter-checkbox:checked`)) || checkbox.name === 'discontinued') {
                checkboxCount = this.elements.subcategoryGrid.querySelectorAll(`.${componentName}__product-filter[data-name="${checkbox.name}"] .${componentName}__product-filter-values[data-value="${checkbox.value}"]`).length;
                countElement.textContent = `(${checkboxCount})`;
            } else {
                checkboxCount = this.elements.subcategoryGrid.querySelectorAll(`.${componentName}__product:not(.filtered-out) .${componentName}__product-filter[data-name="${checkbox.name}"] .${componentName}__product-filter-values[data-value="${checkbox.value}"]`).length;
                countElement.textContent = `(${checkboxCount})`;
            }
            if (checkboxCount > 0) {
                checkbox.disabled = false;
            } else {
                checkbox.disabled = true;
            }
        });
    };

    slideUp = (element, duration = 300) => new Promise((resolve) => {
        element.style.height = `${element.offsetHeight}px`;
        element.style.transitionProperty = 'height, margin, padding';
        element.style.transitionDuration = `${duration}ms`;
        // eslint-disable-next-line no-unused-expressions
        element.offsetHeight; // trigger reflow
        element.style.overflow = 'hidden';
        element.style.height = 0;
        element.style.paddingTop = 0;
        element.style.paddingBottom = 0;
        element.style.marginTop = 0;
        element.style.marginBottom = 0;
        setTimeout(() => {
            element.style.display = 'none';
            element.style.removeProperty('height');
            element.style.removeProperty('padding-top');
            element.style.removeProperty('padding-bottom');
            element.style.removeProperty('margin-top');
            element.style.removeProperty('margin-bottom');
            element.style.removeProperty('overflow');
            element.style.removeProperty('transition-duration');
            element.style.removeProperty('transition-property');
            resolve();
        }, duration);
    });

    slideDown = (element, duration = 300) => new Promise((resolve) => {
        element.style.removeProperty('display');
        let { display } = window.getComputedStyle(element);
        if (display === 'none') display = 'block';
        element.style.display = display;
        const height = element.offsetHeight;
        element.style.overflow = 'hidden';
        element.style.height = 0;
        element.style.paddingTop = 0;
        element.style.paddingBottom = 0;
        element.style.marginTop = 0;
        element.style.marginBottom = 0;
        // eslint-disable-next-line no-unused-expressions
        element.offsetHeight; // trigger reflow
        element.style.transitionProperty = 'height, margin, padding';
        element.style.transitionDuration = `${duration}ms`;
        element.style.height = `${height}px`;
        element.style.removeProperty('padding-top');
        element.style.removeProperty('padding-bottom');
        element.style.removeProperty('margin-top');
        element.style.removeProperty('margin-bottom');
        setTimeout(() => {
            element.style.removeProperty('height');
            element.style.removeProperty('overflow');
            element.style.removeProperty('transition-duration');
            element.style.removeProperty('transition-property');
            resolve();
        }, duration);
    });

    /**
     * Adds slide up/down animation when details element is opened/closed
     * @param {MouseEvent} ev
     */
    handleSummaryClick = (ev) => {
        ev.preventDefault();
        const detailsEl = ev.currentTarget.closest('details');
        const contentEl = detailsEl.querySelector('div');

        if (!detailsEl.open) {
            // Open
            contentEl.style.display = 'none';
            detailsEl.open = true;
            this.slideDown(contentEl);
        } else {
            // Close
            this.slideUp(contentEl).then(() => {
                detailsEl.open = false;
            });
        }
    };

    readUrlParams = () => {
        const urlParams = new URLSearchParams(window.location.search);
        urlParams.forEach((value, key) => {
            if (key === 'keyword') {
                this.state.textSearch = value;
                if (this.elements.textSearchInput) {
                    this.elements.textSearchInput.value = value;
                    this.createFilterChip('textSearch', value, value);
                }
            } else {
                const filterCheckbox = this.elements.filterForm.querySelector(`.${componentName}__filter-checkbox[name="${key}"][value="${encodeURIComponent(value)}"]`);
                if (filterCheckbox) {
                    this.state.filters[key] = [value];
                    filterCheckbox.checked = true;
                    this.createFilterChip(key, encodeURIComponent(value), filterCheckbox.closest(`.${componentName}__filter-checkbox-container`).querySelector('label').textContent);
                }
            }
        });
    };

    initTooltips = () => {
        const tooltipContainers = document.querySelectorAll(`.${componentName}__product-best-selling-tag, .product-family-list__tag--preferred`);

        tooltipContainers.forEach((container) => {
            const tooltip = container.querySelector(`.${componentName}__tooltip`);

            if (!tooltip) return;

            // Show tooltip on mouse enter
            container.addEventListener('mouseenter', () => {
                if (container.getBoundingClientRect().right > (window.innerWidth - 160)) {
                    tooltip.classList.add('tooltip-left');
                } else if (container.getBoundingClientRect().left < 160) {
                    tooltip.classList.add('tooltip-right');
                } else {
                    tooltip.classList.remove('tooltip-left', 'tooltip-right');
                }
                tooltip.style.opacity = '1';
                tooltip.style.visibility = 'visible';
            });

            // Hide tooltip on mouse leave
            container.addEventListener('mouseleave', () => {
                tooltip.style.opacity = '0';
                tooltip.style.visibility = 'hidden';
                tooltip.classList.remove('tooltip-left', 'tooltip-right');
            });

            // Show tooltip on focus (for accessibility)
            container.addEventListener('focus', () => {
                if (container.getBoundingClientRect().right > (window.innerWidth - 160)) {
                    tooltip.classList.add('tooltip-left');
                } else if (container.getBoundingClientRect().left < 160) {
                    tooltip.classList.add('tooltip-right');
                } else {
                    tooltip.classList.remove('tooltip-left', 'tooltip-right');
                }
                tooltip.style.opacity = '1';
                tooltip.style.visibility = 'visible';
            });

            // Hide tooltip on blur (for accessibility)
            container.addEventListener('blur', () => {
                tooltip.style.opacity = '0';
                tooltip.style.visibility = 'hidden';
                tooltip.classList.remove('tooltip-left', 'tooltip-right');
            });
        });
    };

    encodeCatalogNumber = (catalogNumber) => catalogNumber.replaceAll('/', '%252F').replaceAll('.', '%252E');

    getTranslatableProductField = (productJson, field, flattenedField, defaultValue, language) => {
        if (productJson[field] && productJson[field] instanceof Array) {
            try {
                for (let i = 0; i < productJson[field].length; i += 1) {
                    if (productJson[field][i].isocode.toLowerCase() === language.toLowerCase()) {
                        return productJson[field][i].value;
                    }
                }
            } catch (error) {
                console.warn(`Error getting translatable product field ${field} for language ${language}:`, error);
            }
            if (language.toLowerCase() !== 'en') {
                return this.getTranslatableProductField(productJson, field, flattenedField, defaultValue, 'en');
            }
        }
        return productJson[flattenedField] ? productJson[flattenedField].value : defaultValue;
    };

    initI18n = async () => {
        try {
            let lang = this.constants.language.toLowerCase();

            if (this.constants.language === 'zh') {
                lang = 'zh-cn';
            } else if (this.constants.language === 'ko') {
                lang = 'ko-kr';
            }

            const i18nDictionary = await fetch(`/libs/cq/i18n/dict.${lang}.json`);
            const i18nDictionaryJson = await i18nDictionary.json();
            this.constants.i18n = i18nDictionaryJson;
        } catch (error) {
            console.warn(`Error initializing i18n for language ${this.constants.language}:`, error);
        }
    };

    toggleAiTranslationsDisclaimer = (products) => {
        const aiTranslationsDisclaimer = document.querySelector('.ai-translations-disclaimer-text');
        if (aiTranslationsDisclaimer && products.some((product) => product.translate_time)) {
            aiTranslationsDisclaimer.classList.remove('hidden');
        }
    };

    addEventListeners = () => {
        if (this.constants.listType !== 'category') {
            const compareModalClose = document.querySelector(`.${componentName}__compare-modal-close`);
            compareModalClose.addEventListener('click', () => {
                const compareModal = document.querySelector(`.${componentName}__compare-modal`);
                compareModal.classList.remove('active');
            });
            compareModalClose.addEventListener('keydown', (event) => {
                if (event.key === 'Enter') {
                    compareModalClose.click();
                }
            });
            const compareModalRemoveButtons = document.querySelectorAll(`.${componentName}__compare-modal-item-remove`);
            compareModalRemoveButtons.forEach((removeButton, index) => {
                removeButton.addEventListener('click', () => {
                    const catalogNumber = this.elements.compareItems[index].dataset.sku;
                    this.removeCompareFrame(index, catalogNumber);
                    const compareButton = document.querySelector(`.${componentName}__product-compare-checkbox[data-sku="${catalogNumber}"]`);
                    if (compareButton) {
                        compareButton.checked = false;
                    }
                    const compareButtons = document.querySelectorAll(`.${componentName}__product-compare-checkbox`);
                    compareButtons.forEach((button) => {
                        button.disabled = false;
                    });
                });
                removeButton.addEventListener('keydown', (event) => {
                    if (event.key === 'Enter') {
                        removeButton.click();
                    }
                });
            });
            const compareModalRemoveAll = document.querySelector(`.${componentName}__compare-modal-remove-all`);
            compareModalRemoveAll.addEventListener('click', () => {
                this.state.userCompareData = [];
                window.localStorage.setItem('userCompareData', this.state.userCompareData.join(', '));
                this.removeAllCompareFrames();
                const compareButtons = document.querySelectorAll(`.${componentName}__product-compare-checkbox`);
                compareButtons.forEach((button) => {
                    button.checked = false;
                    button.disabled = false;
                });
            });
            document.addEventListener('visibilitychange', () => {
                if (document.visibilityState === 'visible') {
                    this.refreshCompareData();
                }
            });
        }
        this.elements.filterForm.addEventListener('submit', (ev) => {
            ev.preventDefault();
        });
        this.elements.filterClearAll.addEventListener('click', async () => {
            this.elements.filterForm.reset();
            this.elements.chipContainer.querySelectorAll(`.${componentName}__chip`).forEach((chip) => {
                if (!chip.classList.contains(`${componentName}__chip-template`)) {
                    chip.remove();
                }
            });
            if (this.constants.listType !== 'search') {
                this.state.textSearch = '';
            }
            // this.elements.filterForm.querySelectorAll(`.${componentName}__filter-slider-container`).forEach((rangeInput) => {
            //     if (!rangeInput.classList.contains(`${componentName}__filter-slider-container-template`)) {
            //         const rangeInput1 = rangeInput.querySelector(`.${componentName}__filter-slider-range[data-index="0"]`);
            //         const rangeInput2 = rangeInput.querySelector(`.${componentName}__filter-slider-range[data-index="1"]`);
            //         rangeInput1.value = rangeInput1.min;
            //         rangeInput2.value = rangeInput2.max;
            //         this.fillSlider(rangeInput1, rangeInput2, '#949494', '#003E7E', rangeInput1);
            //     }
            // });
            await this.handleProductFilterChange();
            // [...this.elements.productSortInputsMobile].find((input) => input.value === this.state.sortBy).checked = true;
        });
        this.elements.filterClearAll.addEventListener('keydown', (ev) => {
            if (ev.key === 'Enter') {
                this.elements.filterClearAll.click();
            }
        });
        this.elements.filterCheckboxes.forEach((checkbox) => {
            checkbox.addEventListener('change', () => {
                if (checkbox.checked) {
                    this.createFilterChip(checkbox.name, checkbox.value, checkbox.closest(`.${componentName}__filter-checkbox-container`).querySelector('label').textContent);
                } else {
                    this.elements.chipContainer.querySelector(`[data-name="${checkbox.name}"][data-value="${checkbox.value}"]`).remove();
                }
                this.handleProductFilterChange();
            });
        });
        this.elements.paginationForm.addEventListener('submit', this.handlePaginationFormSubmit);
        this.elements.paginationForm.querySelector(`.${componentName}__pagination-button[name="prev"]`).addEventListener('click', () => {
            this.updatePageIndex(this.state.pageIndex - 1);
        });
        this.elements.paginationForm.querySelector(`.${componentName}__pagination-button[name="prev"]`).addEventListener('keydown', (ev) => {
            if (ev.key === 'Enter') {
                this.elements.paginationForm.querySelector(`.${componentName}__pagination-button[name="prev"]`).click();
            }
        });
        this.elements.paginationForm.querySelector(`.${componentName}__pagination-button[name="next"]`).addEventListener('click', () => {
            this.updatePageIndex(this.state.pageIndex + 1);
        });
        this.elements.paginationForm.querySelector(`.${componentName}__pagination-button[name="next"]`).addEventListener('keydown', (ev) => {
            if (ev.key === 'Enter') {
                this.elements.paginationForm.querySelector(`.${componentName}__pagination-button[name="next"]`).click();
            }
        });
        this.elements.paginationForm.querySelector(`.${componentName}__pagination-input`).addEventListener('input', (event) => {
            const input = event.target;
            const inputError = input.parentElement?.querySelector(`.${componentName}__pagination-error`);

            if (!inputError) return;

            if (!inputError.classList.contains('is-visible')) {
                return;
            }

            if (input.validity.valid) {
                inputError.classList.remove('is-visible');
                inputError.style.removeProperty('--pagination-error-max-width');
            } else {
                input.checkValidity();
            }
        });
        this.elements.paginationForm.querySelector(`.${componentName}__pagination-input`).addEventListener('invalid', (event) => {
            event.preventDefault();
            const input = event.target;
            const inputError = input.parentElement?.querySelector(`.${componentName}__pagination-error`);
            const errorText = inputError?.querySelector(`.${componentName}__pagination-error-text`);

            if (!inputError || !errorText) return;

            inputError.classList.add('is-visible');
            const { validity } = input;

            if (validity.rangeUnderflow) {
                errorText.textContent = `${this.constants.i18n['Value must be greater than or equal'] || 'Value must be greater than or equal'}  ${input.min}`;
            } else if (validity.rangeOverflow) {
                errorText.textContent = `${this.constants.i18n['Value must be less than or equal to'] || 'Value must be less than or equal to'}  ${input.max}`;
            } else if (validity.badInput || validity.typeMismatch) {
                errorText.textContent = this.constants.i18n['Please enter a number.'] || 'Please enter a number';
            } else {
                errorText.textContent = input.validationMessage;
            }

            setCenteredMaxWidth(input, inputError, '--pagination-error-max-width');

            if (!input.restorePaginationHandler) {
                input.restorePaginationHandler = (e) => {
                    if (!input.contains(e.target)) {
                        if (inputError.classList.contains('is-visible')) {
                            // Skip the immediate blur re-validation caused by this outside click.
                            input.skipNextPaginationBlurValidation = true;
                            input.value = String(this.state.pageIndex + 1);
                            inputError.classList.remove('is-visible');
                            inputError.style.removeProperty('--pagination-error-max-width');
                        }
                        document.removeEventListener('pointerdown', input.restorePaginationHandler);
                        input.restorePaginationHandler = null;
                    }
                };
                setTimeout(() => document.addEventListener('pointerdown', input.restorePaginationHandler), 0);
            }
        });
        this.elements.paginationForm.querySelector(`.${componentName}__pagination-input`).addEventListener('blur', (event) => {
            const input = event.target;

            if (input.skipNextPaginationBlurValidation) {
                input.skipNextPaginationBlurValidation = false;
                return;
            }

            if (!input.validity.valid) {
                input.checkValidity();
            } else if (Number(input.value) !== this.state.pageIndex + 1) {
                this.elements.paginationForm.requestSubmit(
                    this.elements.paginationForm.querySelector('[name="input-submitter"]')
                );
            }
        });
        this.elements.paginationForm.querySelector(`.${componentName}__pagination-input`).addEventListener('change', (event) => {
            if (!event.target.validity.valid) return;
            this.updatePageIndex(parseInt(event.target.value, 10) - 1);
        });
        this.elements.resultsPerPageSelect.addEventListener('change', this.handleResultsPerPageChange);
        // this.elements.productSortSelect.addEventListener('change', (ev) => {
        //     this.handleProductSortChange(ev.target.value);
        //     [...this.elements.productSortInputsMobile].find((input) => input.value === this.state.sortBy).checked = true;
        // });
        // [...this.elements.productSortInputsMobile].forEach((input) => {
        //     input.addEventListener('change', (ev) => {
        //         this.elements.productSortSelect.querySelector(`option[value="${input.value}"]`).selected = true;
        //         this.elements.productSortSelect.dispatchEvent(new Event('change'));
        //         const selectedOptionIndex = [...this.elements.productSortSelect.options].findIndex((option) => option.value === input.value);
        //         this.elements.productSortSelectStyler.querySelector('summary span').textContent = this.elements.productSortSelect.querySelector(`option[value="${input.value}"]`).textContent;
        //         this.elements.productSortSelectStyler.querySelectorAll('ul[role="listbox"] li').forEach((option, index) => {
        //             option.setAttribute('aria-selected', index === selectedOptionIndex);
        //         });
        //     });
        // });
        this.elements.mobileFilterOpenButton.addEventListener('click', () => {
            this.elements.filterContainer.classList.add('active');
            document.body.classList.add('no-scroll');
        });
        this.elements.mobileFilterOpenButton.addEventListener('keydown', (ev) => {
            if (ev.key === 'Enter') {
                this.elements.mobileFilterOpenButton.click();
            }
        });
        [...this.elements.mobileFilterCloseButtons].forEach((button) => {
            button.addEventListener('click', () => {
                this.elements.filterContainer.classList.remove('active');
                document.body.classList.remove('no-scroll');
            });
            button.addEventListener('keydown', (ev) => {
                if (ev.key === 'Enter') {
                    button.click();
                }
            });
        });

        if (this.elements.textSearchInput) {
            this.elements.textSearchInput.addEventListener('keydown', (ev) => {
                this.state.textSearch = ev.target.value.trim();
                if (ev.key === 'Enter') {
                    if (this.state.textSearch !== '' && !this.elements.chipContainer.querySelector('[data-name="textSearch"]')) {
                        this.createFilterChip('textSearch', this.state.textSearch, this.state.textSearch);
                    } else if (this.state.textSearch !== '' && this.elements.chipContainer.querySelector('[data-name="textSearch"]')) {
                        this.elements.chipContainer.querySelector('[data-name="textSearch"]').querySelector(`.${componentName}__chip-text`).textContent = this.state.textSearch;
                    } else if (this.state.textSearch === '' && this.elements.chipContainer.querySelector('[data-name="textSearch"]')) {
                        this.elements.chipContainer.querySelector('[data-name="textSearch"]').remove();
                    }
                    this.handleTextSearchChange();
                }
            });
        }

        this.elements.compareItems.forEach((item) => {
            item.querySelector('img').addEventListener('error', (ev) => {
                if (ev.target.src === this.getDefaultImage()) {
                    return;
                }
                ev.target.src = this.getDefaultImage();
            });
        });

        this.elements.filterForm.querySelectorAll(`.${componentName}__filter-summary`).forEach((summary) => {
            summary.addEventListener('click', this.handleSummaryClick);
            summary.addEventListener('keydown', (ev) => {
                if (ev.key === 'Enter') {
                    this.handleSummaryClick(ev);
                }
            });
        });
    };

    initDom = async () => {
        this.constants.app = this.elements.container.getAttribute('data-app') ? this.elements.container.getAttribute('data-app') : 'RA';
        if (document.documentElement.lang === 'zh-TW') {
            this.constants.language = 'zh-tw';
        } else if (document.documentElement.lang) {
            this.constants.language = document.documentElement.lang.split('-')[0].toLocaleLowerCase();
        }
        this.showSpinner();
        if (this.constants.language !== 'en') {
            await this.initI18n();
        }
        this.constants.listType = this.elements.container.getAttribute('data-list-type');
        this.constants.categoryIds = this.elements.container.getAttribute('data-category-list');
        this.constants.featureFacets.pimBaba.name = this.elements.content.getAttribute('data-baba-text') || this.constants.featureFacets.pimBaba.name;
        this.constants.featureFacets.pimBaba.icon = this.elements.content.getAttribute('data-baba-icon') || this.constants.featureFacets.pimBaba.icon;
        this.constants.featureFacets.dpp.name = this.elements.content.getAttribute('data-dpp-text') || this.constants.featureFacets.dpp.name;
        this.constants.featureFacets.dpp.icon = this.elements.content.getAttribute('data-dpp-icon') || this.constants.featureFacets.dpp.icon;
        this.constants.featureFacets.ecodesign.name = this.elements.content.getAttribute('data-ecodesign-text') || this.constants.featureFacets.ecodesign.name;
        this.constants.featureFacets.ecodesign.icon = this.elements.content.getAttribute('data-ecodesign-icon') || this.constants.featureFacets.ecodesign.icon;
        this.constants.featureFacets.repairable.name = this.elements.content.getAttribute('data-repairable-text') || this.constants.featureFacets.repairable.name;
        this.constants.featureFacets.repairable.icon = this.elements.content.getAttribute('data-repairable-icon') || this.constants.featureFacets.repairable.icon;
        this.constants.featureFacets.registrable.name = this.elements.content.getAttribute('data-registrable-text') || this.constants.featureFacets.registrable.name;
        this.constants.featureFacets.registrable.icon = this.elements.content.getAttribute('data-registrable-icon') || this.constants.featureFacets.registrable.icon;
        const locale = document.documentElement.lang ? document.documentElement.lang.toLocaleLowerCase() : 'en-us';
        this.constants.countryCode = locale.split('-')[1].toUpperCase();
        this.constants.onlyDiscontinuedProducts = this.elements.content.getAttribute('data-only-discontinued-products') === 'true';
        this.initTooltips();
        if (this.constants.listType === 'category') {
            this.state.totalResults = this.elements.subcategoryGrid.children.length;
            this.state.totalPages = Math.ceil(this.state.totalResults / this.state.resultsPerPage);
            this.elements.filterCheckboxes = this.element.querySelectorAll(`.${componentName}__filter-checkbox`);
            // this.handleProductSortChange(this.elements.productSortSelect.value);
            this.readUrlParams();
            this.handleProductFilterChange();
            this.updateCategoryFacetCounts();
        } else {
            const productResults = await this.getProducts();
            if (this.constants.language !== 'en') {
                this.toggleAiTranslationsDisclaimer(productResults.dataList);
            }
            this.state.totalResults = productResults.totalNumber;
            this.state.totalPages = Math.ceil(this.state.totalResults / this.state.resultsPerPage);
            this.initFacets(productResults.facets);
            this.addFacets();
            this.readUrlParams();
            if (this.constants.onlyDiscontinuedProducts) {
                this.state.filters.discontinued = 'true';
                this.createFilterChip('discontinued', 'true', this.elements.filterForm.querySelector(`.${componentName}__filter-checkbox[data-name="discontinued"] ~ label`)?.textContent || this.constants.i18n['Include Discontinued Products'] || 'Include Discontinued Products');
            }
            await this.handleProductFilterChange();
            this.refreshCompareData();
        }
        this.elements.paginationForm.querySelector(`.${componentName}__pagination-input`).setAttribute('max', this.state.totalPages);
        this.elements.paginationForm.querySelector(`.${componentName}__pagination-input`).setAttribute('value', this.state.pageIndex + 1);
        [...this.element.querySelectorAll(`.${componentName}__pagination-end-index`)].forEach((endIndex) => {
            endIndex.textContent = Math.min(this.state.resultsPerPage, this.state.totalResults);
        });
        [...this.element.querySelectorAll(`.${componentName}__pagination-total-count`)].forEach((totalCount) => {
            totalCount.textContent = this.state.totalResults;
        });
        this.elements.paginationForm.querySelector('span[data-name="page-count"]').textContent = this.state.totalPages;
        if (!(this.state.totalPages === 1)) {
            this.elements.paginationForm.querySelector(`.${componentName}__pagination-input`).removeAttribute('disabled');
            this.elements.paginationForm.querySelector(`.${componentName}__pagination-button[name="next"]`).removeAttribute('disabled');
        }
        this.hideSpinner();
    };

    /**
     * Initialize Component
     */
    init = async () => {
        await this.initDom();
        this.addEventListeners();
    };
}

registerComponent(`.${componentName}`, ProductFamilyList);
